<template>
	<div class="relative w-full h-full" id="main_container">
		<img src="images/1x_images/bg.png" srcset="images/2x_images/bg.png 2x" class="img-bg" />
		<!-- <audio id="bgMusicEl" ref="bgMusicEl" src="audio/background.mp3" loop volume="1"></audio> -->
		<!-- <p class="fixed top-[100px] left-0 z-[999] text-[30px] p-[30px]">{{ test }}</p> -->
		<!-- main header -->
		<div class="absolute top-[20px] w-full z-[99] h-[50px] px-[30px]" id="main_nav">
			<div class="relative flex items-center w-full h-full">
				<div class="flex justify-between items-center gap-[10px] absolute left-0 lang-menu">
					<!-- <img alt="" src="images/1x_images/btn-lang.png" srcset="images/2x_images/btn-lang.png 2x" class="relative left-0" /> -->
					<div class="w-[40px] aspect-square text-white text-[17.5px] flex justify-center items-center rounded-full bg-[#c2ad6c]" @click="showLang = !showLang">EN</div>
					<div class="lang w-[40px] aspect-square text-white text-[17.5px] flex justify-center items-center rounded-full bg-[#b2b2b2]" v-show="showLang">中</div>
					<div class="lang w-[40px] aspect-square text-white text-[17.5px] flex justify-center items-center rounded-full bg-[#b2b2b2]" v-show="showLang">TH</div>
				</div>
				<div class="button absolute w-fit h-fit center">
					<img alt="" src="images/1x_images/btn-menu.png" srcset="images/2x_images/btn-menu.png 2x" @click="showMenu()" />
				</div>
				<div class="button absolute w-fit h-fit right-0">
					<img alt="" src="images/1x_images/btn-sound.png" srcset="images/2x_images/btn-sound.png 2x" @click="toggleSound()" id="audioBtnEl" />
				</div>
				<!-- <div class="w-[110px]"><img alt="" src="images/1x_images/btn-audio.png" srcset="images/2x_images/btn-audio.png 2x" class="relative right-0 opacity-0" /></div> -->
			</div>
		</div>
		<div class="relative w-full h-full overflow-hidden">
			<div class="relative w-full h-full will-change-transform flex" ref="containerEl" @touchmove="handleTouchMove">
				<Main1 ref="section1El" @next="goTo" @playBG="playBgMusic()" />
				<Main2 ref="section2El" @next="goTo" />
			</div>
		</div>
		<div class="modal" ref="menuEl">
			<div class="relative flex flex-col justify-center items-center top-[130px]">
				<img alt="" class="relative button" src="images/1x_images/btn-close.png" srcset="images/2x_images/btn-close.png 2x" @click="closeMenu()" />
				<div class="overflow-hidden w-fit h-fit mt-[40px] rounded-t-[32px]">
					<img alt="" class="relative" src="images/1x_images/menu-1.png" srcset="images/2x_images/menu-1.png 2x" @touchstart="rollover" @touchend="rolloverEnd" @click="goTo(1)" />
				</div>
				<div class="overflow-hidden rounded-b-[32px]">
					<img alt="" class="relative" src="images/1x_images/menu-2.png" srcset="images/2x_images/menu-2.png 2x" @touchstart="rollover" @touchend="rolloverEnd" @click="goTo(2)" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";
import Main1 from "./screens/01_skin_intel/main.vue";
import Main2 from "./screens/02_the_serum/main.vue";
import { NativeAudio } from "@capgo/native-audio";

export default {
	components: { Main1, Main2 },
	data() {
		return {
			scrollTimer: null,
			currentPage: 1,
			test: 123,
			showLang: false,
		};
	},
	methods: {
		handleTouchStart(e) {},
		handleTouchMove(e) {
			// console.log(e)
			if ((e.target.closest(".modal") && !e.target.closest(".asset-container")) || e.target.closest(".video-bar")) {
				e.preventDefault();
			}
		},
		showMenu() {
			gsap.set(this.$refs.menuEl, { autoAlpha: 1 });
		},
		closeMenu() {
			gsap.set(this.$refs.menuEl, { autoAlpha: 0 });
		},
		goTo(type) {
			console.log("goTo", type);
			this.closeMenu();
			if (type == 1) {
				this.$refs.section1El.resetScroll();
				if (currentSection == 1) return;
				// prettier-ignore
				gsap.to(this.$refs.containerEl, { x: 0, force3D: true, ease: "expo.out", duration: 0.5, onComplete: () => {
					currentSection = 1;
					this.$refs.section2El.stopAll();
					this.$refs.section2El.resetScroll();
				}});
			}
			if (type == 2) {
				this.$refs.section2El.resetScroll();
				if (currentSection == 2) return;
				// prettier-ignore
				gsap.to(this.$refs.containerEl, { x: -1024, force3D: true, ease: "expo.out", duration: 0.5, onComplete: () => {
					currentSection = 2;
					this.$refs.section1El.stopAll();
					this.$refs.section1El.resetScroll();
					this.$refs.section2El.startSection();
				}});
			}
		},
		rollover(e) {
			gsap.to(e.currentTarget, { scale: 1.1, duration: 0.2, ease: "out", overwrite: true });
		},
		rolloverEnd(e) {
			gsap.to(e.currentTarget, { scale: 1, duration: 0.2, ease: "out", overwrite: true });
		},
		toggleSound() {
			window.bgAudio = !window.bgAudio;
			if (window.bgAudio) {
				audioBtnTween.resume();
				NativeAudio.setVolume({
					assetId: "bgMusic",
					volume: 0.3,
				});
			} else {
				audioBtnTween.pause();
				NativeAudio.setVolume({
					assetId: "bgMusic",
					volume: 0,
				});
			}
			// console.log(window.bgAudio);
		},
		playBgMusic() {
			console.log("App.playBgMusic()");
			// this.$bgMusic.play();
			NativeAudio.loop({
				assetId: "bgMusic",
			});
			audioBtnTween = gsap.to("#audioBtnEl", { rotate: 360, duration: 10, ease: "none", overwrite: true, repeat: -1 });
		},
	},
	mounted() {
		gsap.set(this.$refs.menuEl, { autoAlpha: 0 });
		gsap.set(".modal", { autoAlpha: 0 });

		document.querySelectorAll(".button").forEach((btn) => {
			btn.addEventListener("touchstart", (event) => {
				gsap.set(event.currentTarget, { autoAlpha: 0.6, overwrite: true });
			});
			btn.addEventListener("touchend", (event) => {
				gsap.set(event.currentTarget, { autoAlpha: 1, overwrite: true });
			});
		});

		window.addEventListener("touchstart", (e) => {
			if (!e.target.closest(".lang-menu")) {
				this.showLang = false;
			}
		});

		this.$nextTick(() => {
			this.playBgMusic();
		});

		// document.querySelectorAll(".button").forEach((btn) => {
		// 	btn.addEventListener("click", (event) => {
		// 		this.$clickSound.play();
		// 	});
		// });

		// this.test = ratioToOriginal;
	},
};
</script>

<style>
@import url("../public/style.css");

* {
	-webkit-user-drag: none; /* Disable drag in Webkit-based browsers */
	user-drag: none; /* For other browsers */
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	-webkit-touch-callout: none;
	-ms-text-size-adjust: none;
	-webkit-text-size-adjust: none;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	image-rendering: -webkit-optimize-contrast;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
img {
	max-width: unset !important;
	will-change: transform, opacity;
}
html {
	position: relative;
	transform-origin: top left;
	margin: 0;
	width: 1024px;
	height: 1366px;
	touch-action: manipulation;
}
body,
#app {
	position: relative;
	width: 100%;
	height: 100%;
	overflow: hidden;
	background-size: cover;
	background-color: black;
	/* font-size: 16px; */
	font-family: "cronosPro";
}
#main_container {
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
}
.img-bg {
	position: absolute;
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
}
.mainDiv1,
.mainDiv2 {
	width: 1024px;
	height: 100%;
	overflow-x: scroll;
	scroll-snap-type: x mandatory;
	will-change: transform;
}
.mainDiv1::-webkit-scrollbar,
.mainDiv2::-webkit-scrollbar {
	display: none;
}
.parentDiv1,
.parentDiv2 {
	position: relative;
	top: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
	flex-shrink: 0;
	scroll-snap-align: start;
	scroll-snap-stop: always;
}
.childDiv1,
.childDiv2 {
	position: relative;
	width: 100%;
	height: 100%;
	will-change: transform;
	overflow: visible;
	/* display: flex;
	align-items: center; */
	/* transform: translateX(calc(var(--scroll-pos) * -0.5)); */
	/* left: -50%; */
}

.childWrapper {
	position: absolute;
	margin: auto;
	top: 0;
	bottom: 0;
	width: 100%;
	height: 1366px;
}

.center {
	margin: auto;
	left: 0;
	right: 0;
}
.modal {
	position: absolute;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.6);
	display: flex;
	flex-direction: column;
	justify-content: start;
	align-items: center;
	backdrop-filter: blur(10px);
	z-index: 50;
}
</style>
